import { getIsDarkTheme } from 'owa-fabric-theme';
import type { IEditor } from 'roosterjs-editor-types';
import {
    SONORA_INLINE_HINT_CLASS,
    SONORA_INTRO_HINT_ID,
    WHITE_SPACE,
    SUGGESTION_TEXT_COLOR,
    SUGGESTION_TEXT_COLOR_DARK,
} from '../../constants';

const createIntroHintNode = (
    editor: IEditor,
    hintText: string,
    triggerCharacter: string
): HTMLElement => {
    const editorDocument = editor.getDocument();

    const span = editorDocument.createElement('span');
    span.id = SONORA_INTRO_HINT_ID;
    span.className = SONORA_INLINE_HINT_CLASS;
    span.style.whiteSpace = WHITE_SPACE;
    span.style.color = getIsDarkTheme() ? SUGGESTION_TEXT_COLOR_DARK : SUGGESTION_TEXT_COLOR;
    span.setAttribute('contenteditable', 'false');

    // If there is no triggering character placeholder in the string, show the hint as is.
    // Else, show the hint with a boxed triggering character.
    if (hintText.indexOf('{0}') < 0) {
        span.textContent = hintText;
        return span;
    }

    const [prefix, postfix] = hintText.split('{0}');

    const prefixNode = editorDocument.createElement('span');
    prefixNode.textContent = ` ${prefix} `;
    span.appendChild(prefixNode);

    const triggerCharacterIcon = editorDocument.createElement('span');
    triggerCharacterIcon.textContent = triggerCharacter;
    triggerCharacterIcon.style.borderRadius = '2px';
    triggerCharacterIcon.style.borderStyle = 'solid';
    triggerCharacterIcon.style.borderWidth = '1px';
    triggerCharacterIcon.style.borderColor = getIsDarkTheme()
        ? SUGGESTION_TEXT_COLOR_DARK
        : SUGGESTION_TEXT_COLOR;
    triggerCharacterIcon.style.fontSize = '0.7em';
    triggerCharacterIcon.style.paddingLeft = '5px';
    triggerCharacterIcon.style.paddingRight = '5px';
    triggerCharacterIcon.style.paddingTop = '1px';
    triggerCharacterIcon.style.paddingBottom = '1px';
    triggerCharacterIcon.style.position = 'relative';
    triggerCharacterIcon.style.top = '-1px';
    span.appendChild(triggerCharacterIcon);

    const postfixNode = editorDocument.createElement('span');
    postfixNode.textContent = ` ${postfix}`;
    span.appendChild(postfixNode);

    return span;
};

export default createIntroHintNode;
